<template>
  <table class="table">
    <tbody>
      <tr v-for="item in value.rows">
        <td v-for="cell in item.cells">
          <template v-for="textItem in cell.content">
            <PortableText :value="textItem" :components="components" />
          </template>
        </td>
      </tr>
    </tbody>
  </table>
</template>
<script lang="ts" setup>
import PtComponent from './PtComponent.vue'
import PtImage from './PtImage.vue'
import PtTable from './PtTable.vue'
import PtItemLink from './PtItemLink.vue'
import { PortableText } from '@portabletext/vue'
import PtSuperscript from './PtSuperscript.vue'
import type {
  PortableTextMarkComponent,
  PortableTextTypeComponent,
  PortableTextVueComponents
} from '@portabletext/vue'

const props = defineProps({
  value: {
    type: Object,
    required: true
  }
})

const value = props.value
const components = {
  types: {
    component: PtComponent,
    image: PtImage,
    table: PtTable
  } as PortableTextTypeComponent,
  marks: {
    internalLink: PtItemLink,
    link: PtItemLink,
    sup: PtSuperscript
  } as PortableTextMarkComponent
} as PortableTextVueComponents
</script>
